import { Cookies, Stylist } from 'services';
import { updateSingleBooking } from 'store/booking/actions';
import { SingleBookingStatus } from 'store/booking/types';

export const STYLIST_LOADING_START = 'STYLIST_LOADING_START';
export const STYLIST_LOAD_START = 'STYLIST_LOAD_START';
export const SET_STYLIST = 'SET_STYLIST';

export const SET_STYLIST_REVIEWS = 'SET_STYLIST_REVIEWS';

export const UPDATE_STYLIST_FAVORITES = 'UPDATE_STYLIST_FAVORITES';

export const STYLIST_ACTION_FAILED = 'STYLIST_ACTION_FAILED';

export const stylistLoadingStart = () => ({
    type: STYLIST_LOADING_START
});

export const stylistLoadStart = () => ({
    type: STYLIST_LOAD_START
});

export const setStylist = (stylist) => ({
    type: SET_STYLIST,
    payload: { stylist }
});

export const setStylistReviews = (reviews) => ({
    type: SET_STYLIST_REVIEWS,
    payload: { reviews }
});

export const updateStylistFavorites = ({ items = [], total_count }) => ({
    type: UPDATE_STYLIST_FAVORITES,
    payload: { items, total_count }
});

export const stylistActionFailed = (error, type) => ({
    type: STYLIST_ACTION_FAILED,
    payload: { error: { ...error, type } }
});

export const endSession = (session_id) => {
    return async (dispatch) => {
        try {
            const { token } = Cookies.get('user');
            await Stylist.endSession(session_id, token);
            updateSingleBooking(dispatch, session_id, SingleBookingStatus.requestEndSession);
        } catch (error) {
            dispatch(stylistActionFailed(error, 'endsession'));
        }
    };
};

export const loadStylistFavorites = (params = {}) => {
    return async (dispatch, getState) => {
        try {
            const user = Cookies.get('user');
            const { favorites } = getState().stylists;
            if (user) {
                if (!params.from) params.from = 0;
                if (!params.count) params.count = 100;
                const {
                    data: { items, total_count }
                } = await Stylist.favorites(user.uuid, params);
                dispatch(
                    updateStylistFavorites({
                        items: params.from === 0 ? items : [...favorites, ...items],
                        total_count
                    })
                );
            }
        } catch (error) {
            dispatch(stylistActionFailed(error, 'loadclient'));
        }
    };
};

export const favorite = (favouritesFilter) => {
    return async (dispatch, getState) => {
        try {
            const { favorites } = getState().stylists;
            const user = Cookies.get('user');

            if (!user) return;
            const itemIndex = getItemIndex(
                favorites,
                favouritesFilter.item,
                favouritesFilter.attribute
            );
            const isExist = itemIndex > -1;

            if (!isExist) {
                await Stylist.favorite(user.uuid, favouritesFilter.item);
            } else {
                const uniqueId =
                    favouritesFilter.attribute === 'uuid' ? 'item_uuid' : 'originalItemUnique';
                await Stylist.storeRemove(user.uuid, [favorites[itemIndex][uniqueId]]);
            }
            dispatch(
                loadStylistFavorites({
                    ...favouritesFilter.params,
                    from: 0,
                    gender: favouritesFilter.gender
                })
            );
        } catch (error) {
            dispatch(stylistActionFailed(error, 'favorite'));
        }
    };
};

const getItemIndex = (favorites, item, attr) => {
    return favorites.findIndex((favorite) =>
        attr === 'product_id'
            ? favorite?.sku[0] === item?.sku[0]
            : favorite.originalItemUnique === item[attr] || favorite.uuid === item[attr]
    );
};
